<template>
  <div class="integral">
    <div class="header">
      <img class="bg" src="@/assets/person/dp-gr-jf2.png" />
      <div class="second-line">
        <i class="el-icon-back" @click="goBack"></i>
        <span>我的积分</span>
      </div>
      <div class="third-line">
        <p>
          {{firstName}}:
          <span>{{integral}}</span>
        </p>
        <p v-if="jurisdction" @click="toggle">{{secondName}}<img src="@/assets/person/dp-gr-jf1.png" alt /></p>
        
      </div>
      <div class="four-line">
        <button @click="goDetail">积分记录</button>
        <button @click="goRecord">积分细则</button>
      </div>
      <!-- <div class="fif-line">
        <div>
          <p>点击签到</p>
        </div>
      </div>
      <div class="six-line"></div> -->
    </div>

    <div class="content">
      <!-- <div class="week-box">
        <div class="week-template" v-for="week in weeks" :key="week.day">
          <p v-if="week.sign=='未签到'">{{week.sign}}</p>
          <img v-else :src="state.sign" alt />
          <p>{{week.day}}</p>
        </div>
      </div> -->

      <div class="integarl-introduce">
        <div class="title">
          <img src="@/assets/person/dp-gr-jf3.1.png" alt />
          <span>每日任务领取积分</span>
        </div>

        <div class="integarl-box">
          <div class="integral-template" v-show="firstName=='我的个人积分'" v-for="integral in integrals" :key="integral.title">
            <div>
              <p>{{integral.title}}</p>
              <p>{{integral.introduce}}</p>
              <p>
                <span :style="{width:integral.run}"></span>
              </p>
            </div>
            <button :class="integral.states=='去看看'?'yellow':'gral'">{{integral.states}}</button>
          </div>
          <div class="party-template" v-for="(party,index) in partyGrals" :key="index" v-show="firstName=='党组织积分'">
            <div>
              <p>{{party.title}}</p>
              <p>{{party.introduce}}</p>
            </div>
            <button :class="party.states=='去看看'?'yellow':'gral'">{{party.states}}</button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      state: {
        noSign: "未签到",
        sign: require("@/assets/person/dp-gr-jf4.png"),
        today: require("@/assets/person/dp-gr-jf4.1.png"),
        noday: require("@/assets/person/dp-gr-jf4.2.png")
      },
      integrals: [
        {
          name:'阅读文章',
          title: "1分/每有效阅读一篇文章",
          introduce: "已获1分/上限5分",
          upper:5,
          states: "去看看",
          run: "0%"
        },
        {
          name:'学习课件',
          title: "1分/每有效学习一次课件",
          introduce: "已获2分/上限5分",
          upper:5,

          states: "去看看",
          run: "0%"
        },
        {
          name:'收藏',
          title: "1分/每有效收藏一次",
          introduce: "已获0分/上限3分",
          upper:3,
          states: "去看看",
          run: "0%"
        },
        {
          name:'登录',
          title: "1分/登录",
          introduce: "已获0分/上限1分",
          upper:1,
          states: "去看看",
          run: "0%"
        }
      ],
      partyGrals:[
        {
          name:'上传三会一课',
          title: "2分/每有效上传三会一课动态",
          introduce: "已获0分/无上限",
          states: "去看看",
        },
        {
          name:'后台上传资料',
          title: "1分/后台每上传一次资料",
          introduce: "已获0分/无上限",
          states: "去看看",
        },
      ],
      weeks: [],
      firstName: "我的个人积分",
      secondName: "党组织积分",
      integral:0
    };
  },
  methods: {
    getdata() {
      let array = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
      let Dates = new Date();
      let num = Dates.getDay() - 1;
      let oddnum = num;
      for (let x = 3; x > 0; x--) {
        //从周一赋值到周三
        let tempNum = oddnum - x;
        if (tempNum < 0) tempNum = tempNum + 7;
        this.weeks.push({ day: array[tempNum], sign: "未签到" });
      }
      this.weeks.push({ day: array[num], sign: "未签到" });
      for (let x = 1; x < 4; x++) {
        //取值为1是因为我们已经手动赋值了今天
        //赋值后三个
        let tempNum = oddnum + x;
        if (tempNum >= 7) tempNum = tempNum - 7;
        this.weeks.push({ day: array[tempNum], sign: "未签到" });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goRecord() {
      if (this.firstName=="我的个人积分")
        this.$router.push({
          path: "/person/integral/integralrecord",
          query: { title: "个人积分说明" }
        });
      else
        this.$router.push({
          path: "/person/integral/integralrecord",
          query: { title: "党组织积分明细" }
        });
    },
    goDetail() {
      this.$router.push({ path: "/person/integral/integraldetail",query:{integral:this.integral} });
    },
    getMsg() {
      this.axios
        .post("/api/Personal/Integral", {
          token: sessionStorage.getItem("token"),
          status: this.firstName == "我的个人积分" ? 0 : 1
        })
        .then(e => {     
          console.log(e.data);
          
          if(0 == e.data.code ){
            this.integral = e.data.count
            if(this.firstName == '我的个人积分'){
              e.data.msg.filter(item=>{
                this.integrals.forEach(inte =>{
                  if(item.scoreDescrible == inte.name){
                     let tempArr =  inte.introduce.split('/')
                     inte.introduce = `已获${item.Addscore}分/${tempArr[1]}`
                     inte.run = item.Addscore * 100 / inte.upper +'%',
                     inte.states = item.Addscore == inte.upper ?"已完成":'去看看'
                  }
                })
              })
            }else{
              e.data.msg.filter(item=>{
                this.integrals.forEach(inte =>{
                  if(item.scoreDescrible == inte.name){
                     let tempArr =  inte.introduce.split('/')
                     inte.introduce = `已获${item.Addscore}分/${tempArr[1]}`
                     inte.states = item.Addscore == inte.upper ?"已完成":'去看看'

                  }
                })
              })
            }
            
          }
        });
    },
    toggle(){
      let temp = this.firstName
      this.firstName = this.secondName;
      this.secondName = temp;
      this.getMsg()
    }
  },
  computed:{
    jurisdction:function(){
      return sessionStorage.getItem('status')=='1'?true:false
    }
  }
  ,mounted: function() {
    this.getMsg();
    this.getdata();
  }
};
</script>
<style lang='scss' scoped>
.integral {
  .content {
    .integarl-introduce {
      .party-template,
      .integral-template {
        .gral {
          border: solid 0.02rem #cccccc;
          background-color: #eeeeee;
          color: #999999;
        }
        .yellow {
          color: #ffffff;
          border: solid 0.02rem #de8f13;
          background-image: linear-gradient(0deg, #fbab30 0%, #fdc122 100%);
        }
        div {
          p {
            &:nth-child(2) {
              color: #999999;
              line-height: 2;
            }
            &:nth-child(3) {
              span {
                transition: width 0.5s;
                -webkit-transition: width 0.5s;
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                background: #eb9739;
                height: 0.12rem;
                border-radius: 0.06rem;
              }
              border-radius: 0.06rem;
              background-color: #f4f4f4;
              height: 0.12rem;
              width: 50%;
              position: relative;
            }
          }
          margin-left: 5%;
          width: 70%;
        }
        button {
          margin-left: auto;
          margin-right: 2%;
          font-size: 0.3rem;
          border-radius: 0.26rem;
          padding: 0.1rem 0.2rem;
          border: 0;
        }
        padding: 0.3rem 0;
        width: 90%;
        margin: 0.2rem auto;
        box-shadow: 0px 0px 0.18rem 0px rgba(0, 0, 0, 0.06);
        border-radius: 0.12rem;
        display: flex;
        align-items: center;
      }
      img {
        width: 0.33rem;
        height: 0.33rem;
        margin-right: 0.2rem;
      }
      span {
        font-weight: bold;
      }
      .title {
        line-height: 3;
        padding: 0 2%;
        display: flex;
        align-items: center;
      }
    }
    .week-box {
      .week-template {
        p {
          &:nth-child(1) {
            color: #999999;
            font-size: 0.24rem;
          }
          &:nth-child(2) {
            font-size: 0.28rem;
          }
        }
        img {
          width: 0.25rem;
          height: 0.2rem;
        }
        width: 14%;
        text-align: center;
      }
      display: flex;
      align-items: center;
      // padding-top: 1rem;
    }

    background: #fff;
    padding-bottom: 1rem;
    width: 94%;
    margin: 0 auto;
    box-shadow: 1px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 0.16rem;
    border-bottom-right-radius: 0.16rem;
  }
  .header {
    .six-line {
      background: #fff;
      height: 1rem;
      position: absolute;
      bottom: 0rem;
      width: 94%;
      left: 3%;
      border-top-left-radius: 0.16rem;
      border-top-right-radius: 0.16rem;
    }
    .fif-line {
      div {
        p {
          width: 80%;
          height: 80%;
          color: #fff;
          background-image: linear-gradient(0deg, #fd5940 0%, #ffaa3e 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        display: inline-flex;
        align-items: center;
        border-radius: 50%;
        background: #fff;
        width: 2rem;
        height: 2rem;
        justify-content: center;
      }
      text-align: center;
      position: absolute;
      width: 100%;
      bottom: 0rem;
      z-index: 3;
    }
    .four-line {
      button {
        border-radius: 0.04rem;
        background-color: #ffffff;
        border: 0;
        padding: 0.1rem 0.2rem;
        color: #eb9739;
        font-size: 0.3rem;
        margin-right: 0.2rem;
      }
      position: absolute;
      top: 2.2rem;
      left: 0.2rem;
    }
    .third-line {
      p {
        &:nth-child(1) {
          span {
            font-size: 0.54rem;
            font-weight: bold;
          }
          border-bottom: 0.01rem solid #e6e6e6;
        }
        &:nth-child(2) {
          margin-left: auto;
          margin-right: 0.2rem;
        }
        line-height: 2;
      }
      img {
        width: 0.15rem;
        height: 0.21rem;
      }
      display: flex;
      align-items: center;
      color: #fff;
      position: absolute;
      top: 1rem;
      width: 94%;
      left: 3%;
    }
    .second-line {
      i {
        margin: 0 0.2rem;
      }
      position: absolute;
      display: flex;
      align-items: center;
      line-height: 2.5;
      position: fixed;
      width: 100%;
      z-index: 9;
      font-size: 0.36rem;
      color: #fff;
      width: 100%;
      top: 0rem;
    }
    .bg {
      width: 100%;
    }
    position: relative;
  }
  min-height: 100vh;
  font-size: 0.3rem;
}
</style>